import { singleSelectColDef } from "components/DataGrid/columnDefs/singleSelectColDef";
import { GridColTypeDef, ValueOptions } from "@mui/x-data-grid-pro";
import { warehouses } from "constants/warehouses";

const warehouseValueOpts: ValueOptions[] = warehouses.map((warehouse) => ({
  value: warehouse.name,
  label: `${warehouse.acronym}`,
}));

export const warehouseColDef: GridColTypeDef = {
  headerName: "WH",
  width: 75,
  ...singleSelectColDef(warehouseValueOpts),
};
